import { createI18n } from 'vue-i18n'
import it from './locales/it.json'
import en from './locales/en.json'
import pt from './locales/pt.json'

// Rileva la lingua del sistema operativo
function getSystemLocale() {
  // Prova diverse proprietà per rilevare la lingua del sistema
  const systemLang = navigator.language || 
                    navigator.languages?.[0] || 
                    navigator.userLanguage || 
                    navigator.browserLanguage
  
  // Estrai solo il codice lingua (es: 'it-IT' -> 'it', 'pt-BR' -> 'pt')
  const langCode = systemLang.split('-')[0].toLowerCase()
  
  // Supporta italiano, inglese e portoghese, default italiano
  const selectedLang = ['it', 'en', 'pt'].includes(langCode) ? langCode : 'it'
  
  console.log(`🌍 Sistema rilevato: ${systemLang} -> Lingua selezionata: ${selectedLang}`)
  
  return selectedLang
}

const messages = {
  it,
  en,
  pt
}

const i18n = createI18n({
  locale: getSystemLocale(),
  fallbackLocale: 'it',
  messages,
  legacy: false // usa Composition API
})

export default i18n